// 养老保险待遇发放明细查询——微信，主流程
const wxMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `query/wx/index${i + 1}`,
  name: `queryWxIndex${i + 1}`,
  component: () => import(`@/views/society/query/wx/index${i + 1}.vue`)
}))

// 养老保险待遇发放明细查询——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `query/zfb/index${i + 1}`,
  name: `queryZfbIndex${i + 1}`,
  component: () => import(`@/views/society/query/zfb/index${i + 1}.vue`)
}))


// 养老保险待遇发放明细查询——皖事通，主流程
const wstMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `query/wst/index${i + 1}`,
  name: `queryWstIndex${i + 1}`,
  component: () => import(`@/views/society/query/wst/index${i + 1}.vue`)
}))

export default {
  path: '/society',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 养老保险待遇发放明细查询——微信，开始
    ...wxMainRoutes,

    // 养老保险待遇发放明细查询——支付宝，主流程
    ...zfbMainRoutes,

    // 养老保险待遇发放明细查询--皖事通, 主流程
    ...wstMainRoutes,
  ]
}
